/* eslint-disable import/prefer-default-export */

import { API_URL } from '../../../../../../../utils/config';

export const FACEBOOK_SITE_URL = `${API_URL}/fbk_sites`;
